import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ApiConstants } from 'src/app/constants/api-constants';
import { ContactUsModalComponent } from 'src/app/global/contact-us-modal/contact-us-modal.component';
import { ServicecallService, SharedService } from 'src/app/services';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  currentYear = new Date().getFullYear();
  token: any = ApiConstants.blobSasToken;
  public tenantConfig: string;
  constructor(
 
    public service: ServicecallService,
    private _sharedData: SharedService,
    private _modalService: NgbModal,
    private _sharedService: ServicecallService
  ) { }

  ngOnInit(): void {
    this.tenantConfig = this._sharedService.getConfiguration('tenantGenericConfig') ? this._sharedService.getConfiguration('tenantGenericConfig')?.tenant : null;
  }

  sheduleDemo(type?: any) {
    this._sharedData.send(true);
    const modalRef = this._modalService.open(ContactUsModalComponent,
      {
        backdrop: 'static',
        keyboard: false,
        windowClass: "ContactModalClass"
      });
    modalRef.componentInstance.type = type;

    modalRef.result.then((_result: any) => {
      this._sharedData.send(false);
    }, (_reason: any) => {
      // TODO document why this arrow function is empty
    });
  }

}
